import styled from 'styled-components';
import {
    min_xs,
    min_sm,
    min_md,
    min_lg,
    min_lm,
    min_xl,
    min_fhd,
    max_xs,
    max_sm,
    max_md,
    max_lg,
    max_lm,
    max_xl,
    max_fhd,
} from "../../variables";
import { BotonOD } from '../common'


let txtSelectCSS = `

  .txt-select{
    &-arrow{
      position:absolute;
      width : 11.6px;
      top: 50%;
      transform: translateY(-50%);
      right: 10px;
      opacity : 0.4;
      transition : all 0.3s ease;
      &-hovered{
        opacity : 1;
        transition : all 0.3s ease;
      }
    }
    &-container{
      position:relative;
    }
    &-menu{
      border: 1px solid #9e9e9e;
      border-radius: 4px;
      background-color: hsl(0,0%,100%);
      box-shadow: 0 0 0 1px hsla(0,0%,0%,0.1), 0 4px 11px hsla(0,0%,0%,0.1);
      margin-top: 16px;
      max-height:300px;
      overflow-y:auto;
      display:block;
      z-index:1;
      position:relative;
      &-closed{
        display:none;
      }
    }
    &-list{
      padding : 0;
      margin:0;
      list-style-type : none;
    }
    &-item{
      box-sizing:border-box;
      font-size: inherit;
      padding: 8px 12px;
      width: 100%;
      :hover{
        background-color: #cccccc;
        cursor:pointer;
      }
      &-selected{
        color : white;
        background-color: #9e9e9e;
        :hover{
          background-color: #9e9e9e;
        }
      }
    }
  }

`

export const Datos_Protegidos = styled.div`
 
  margin: 90px auto 100px auto;
  width: 1117px;
  max-width: calc(100% - 40px);

  .title {
    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    line-height: 40px;
    text-align: center;
    letter-spacing: 1.125px;
    text-transform: uppercase;
    color: #4F5D5B;
  }

  .logo-container {
    
    display: flex;
    margin-top: 55px;
    justify-content: center;

    .amvo {
      margin-right: 20px;
    }

    .sige {
      margin-right: 40px;
    }

    .inai {
      
    }

  }

  @media (max-width: 767px){
    width: 520px;
    .logo-container {
      flex-direction: column;
      align-items: center;
      .amvo {
        margin-bottom: 40px;
        max-width: 256px;
        margin-right: 0px;
      }
  
      .sige {
        margin-bottom: 40px;
        max-width: 256px;
        margin-right: 0px;
      }
  
      .inai {
        max-width: 107px;
      }
    }
  }

`

export const PymeB = styled.div`
    position:relative;
  
    --title-font-size : 45px;
    --title-line-height : 53px;
    --title-margin-top : 24px;
    --title-margin-bottom : 0px;

    --subtitle-font-size : 25px;
    --subtitle-line-height : 38px;
    --subtitle-font-weight : 600;

    --titles-text-align : left;

    --form-width : 580px;
    --form-display : block;
    --form-margin : 0;

    --banner-display : block;
    --banner-width : calc(100% - var(--form-width));
    --banner-max-width : 100%;
    --banner-margin : 0;
    --banner-order: 1;

    --item-min-height : 300px;
    
    --input-field-margin-top : 20px;

    display : flex;
    flex-direction : row;

    max-width: calc(100% - 40px);
    width: 1117px;
    margin: auto;
    margin-bottom: 40px;
    .counter.desktop{
      margin-top : 100px;
    }
    .atras_btn{
      z-index: 1;
      left : 0;
      @media(${min_lg}){
        left : -20px;
      }
    }
    @media(${max_lg}){
        display : block;
        width : 520px;
        max-width : 100%;
        --banner-display : block;
        --banner-order : 0;
        --form-display : block;
        --form-margin : auto;
        --banner-width : 100%;
        --banner-margin : auto;
        --banner-max-width : 520px;
        --title-margin-bottom : 5px;
        --subtitle-font-weight : normal;

        --titles-text-align : center;

        --title-font-size : 30px;
        --title-line-height : 40px;
        --title-margin-top : 20px;
    
        --subtitle-font-size : 20px;
        --subtitle-line-height : 25px;

        --item-min-height : 100px;
        .atras_btn{
          img{
            filter: brightness(0) invert(1);
          }
        }
        .desktop{
          display : none;
      }
    }
    @media(${min_lg}){
        .mobile{
            display : none;
        }
    }
    @media(${max_md}){
      .desktop-img{
        display : none;
      }
    }
    @media(${min_md}){
        .mobile-img{
            display : none;
        }
    }
    @media(${max_md}){
        --title-font-size : 20px;
        --title-line-height : 23px;
    
        --subtitle-font-size : 16px;
        --subtitle-line-height : 18px;
    }

    .pv2__banner{
        display:var(--banner-display);
        vertical-align:top;
        width : var(--banner-width);
        margin : var(--banner-margin);
        max-width : var(--banner-max-width);
        order : var(--banner-order);

        @media(${min_lg}){
          text-align:right;
        }
        img {
          width : 100%;
            @media(${max_md}){
              max-width : 270px;
            }
            @media(${min_lg}){
              width : calc(100% - 42px);
              max-width : 532px;
            }
        }

    }

    
    .pv2__form{
        display:var(--form-display);
        width : var(--form-width);
        vertical-align:top;
        position:relative;
        box-sizing:border-box;
        max-width : 100%;
        @media(${max_lg}){
            padding : 0;
            max-width : calc(100% - 40px);
        }

        margin : var(--form-margin);

        .counter.mobile{
            margin-top : 20px;
        }

        &__title{
            font-family : Raleway;
            font-weight: bold;
            font-size: var(--title-font-size);
            line-height: var(--title-line-height);
            margin-top : var(--title-margin-top);
            margin-bottom : var(--title-margin-bottom);
            text-align : var(--titles-text-align);
        }
        &__subtitle{
            font-family : Raleway;
            font-weight : var(--subtitle-font-weight);
            font-size: var(--subtitle-font-size);
            line-height: var(--subtitle-line-height);
            text-align : var(--titles-text-align);
        }
        

        &__item{
            transition : all 0.4s ease;
            min-height : var(--item-min-height);
            padding-bottom : 20px;
            &.prev_question, &.next_question{
                position:absolute;
                opacity : 0;
                transition : all 0.4s ease;
                overflow:hidden;
                top : 0;
                user-select : none;
                visibility: hidden;
                width : 0;
            }
            &.prev_question{
                left:-5px;
                transform:translateX(-100%);
            }
            &.next_question{
                right:5px;
                transform:translateX(100%);
            }
        }
        &__footer{
            position:relative;
            .counter{
                position:absolute;
                left : 0;
                bottom : 0;
                transform : translateY(50%);
            }
            ${BotonOD}{
                margin : 0;
                margin-left : auto;
                @media(${max_lg}){
                 margin:auto;   
                }
            }
        }
    }
    .input-field{
        margin-top : var(--input-field-margin-top);
    }
    .input-field.half{
      @media(${min_lg}){
        display:inline-block;
        vertical-align:middle;
        width : calc(50% - 9px);
        :nth-child(2n){
          margin-left : 18px;
        }
      }
    }
    .input-container{
        background: #FFFFFF;
        border: 1px solid rgba(180,180,180,0.7);
        box-sizing: border-box;
        border-radius: 6px;
        height : 45px;
        position:relative;

        
      }
      .radio-option{
        display: block;
        border: none;
      }
      .label{
        margin-bottom:21px;
        text-align:left;
        position:relative;
        span{
          color: #9E9E9E;
          font-size : 90%;
        }
        @media(${max_md}){
            margin-bottom : 15px;
        }
    }
      .input-content{
        width : calc(100% - 20px);
        height : 100%;
        margin-left : 9px;
        display:block;
        border:none;
        font-size: 18px;
        line-height: 23px;
        letter-spacing: 0.675px;
        color: #4F5D5B;

        @media(${max_md}){
            font-size : 16px;
            line-height : 20px;
        }


        ::placeholder{
          color: rgba(158, 158, 158,0.6);
          font-family: Source Sans Pro;
          font-style: normal;
          font-weight: 300;
      }
        :focus{
            outline:none;
        }
    }
    .active-field{
        border: 1px solid #F7924E;
      }
      .error-field{
          border: 1px solid #ff7366;
      }
      .warning-container{
          text-align:left;
      }
      .warning-content{
          color : #ff7366;
          font-weight : 300;
      }
      .ready-field{
        border: 1px solid #31AD79;
    }
    .ready-field::after{
        content:url('/assets/form/check_verde.png');
        position:absolute;
        top:0;
        right: 0;
        transform: translate(40%, -50%);
      }

    #pyme_number_field{
        .warning-container, .label{
          // visibility:hidden;
        }
      }
      #pyme_lada_field{
        vertical-align: top;
        width : 103px;
        display : inline-block;
        .label.label, .warning-container {
          width : 387px;
          @media(max-width : 400px){
              width : 300px;
          }
        }
      }
      #pyme_number_field{
      }

    ${txtSelectCSS}
`